import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: '%', value: 'percentage' },
    { label: '€', value: 'absolute' },
]

export default function SelectValueType({...props}) {

    const myProps = {
        label: 'Value type',
        options: OPTIONS,
        isClearable: false, firstSelect: false, isMulti: false,
        icon: { icon: 'abacus' },
        ...props
    }

    return <SelectSeeker {...myProps} />
}